import ServicePageLayout from '../../components/feature/ServicePageLayout';

export default function RealWoodBlindsPage() {
  return (
    <ServicePageLayout
      blindType="Real Wood Blinds"
      heroImage="https://public.readdy.ai/ai/img_res/eb7c73d3d32f933fa541230883f9dc4c.jpg"
      heroTitle="Real Wood Blinds in Northampton"
      heroSubtitle="Premium natural wood venetian blinds that add timeless elegance and warmth to your home"
      introText="For those who appreciate the authentic beauty and warmth of natural wood, our real wood blinds are the perfect choice. Crafted from high-quality timber including basswood, oak, and bamboo, these premium blinds add a touch of luxury and sophistication to any room in your Northampton home. Each blind showcases the natural grain and character of real wood, creating a warm, inviting atmosphere that synthetic materials simply cannot replicate. With expert craftsmanship and professional installation, our real wood blinds are an investment in both style and quality that will enhance your home for years to come."
      features={[
        { icon: 'ri-leaf-line', title: 'Natural Beauty', desc: 'Authentic wood grain and texture that adds warmth and character to your home. Each blind is unique with its own natural patterns.' },
        { icon: 'ri-vip-crown-line', title: 'Premium Quality', desc: 'Crafted from high-quality timber including basswood, oak, and bamboo for exceptional durability and appearance.' },
        { icon: 'ri-temp-hot-line', title: 'Natural Insulation', desc: 'Real wood provides excellent thermal insulation properties, helping to keep your home warm in winter and cool in summer.' },
        { icon: 'ri-palette-line', title: 'Rich Finishes', desc: 'Available in a range of natural wood stains and finishes from light pine to rich walnut, complementing any interior style.' },
        { icon: 'ri-plant-line', title: 'Eco-Friendly Option', desc: 'Sustainably sourced timber options available, making them an environmentally responsible choice for your home.' },
        { icon: 'ri-time-line', title: 'Timeless Appeal', desc: 'Classic design that never goes out of style, adding long-term value and elegance to your property.' },
      ]}
      pricePerBlind="£139"
      wholeHousePrice="£1,099"
      benefits={[
        { icon: 'ri-check-line', text: 'Premium natural timber' },
        { icon: 'ri-check-line', text: 'Expert installation' },
        { icon: 'ri-check-line', text: 'Natural insulation' },
        { icon: 'ri-check-line', text: 'Timeless elegance' },
        { icon: 'ri-check-line', text: 'Eco-friendly options' },
      ]}
      faqs={[
        {
          question: 'What types of wood are used for real wood blinds?',
          answer: 'We offer real wood blinds in several premium timber options including basswood (a popular lightweight choice), oak (for a more traditional look), bamboo (an eco-friendly sustainable option), and other hardwoods. Each type has its own unique grain pattern and characteristics. Our team can show you samples and help you choose the best option for your home.'
        },
        {
          question: 'Can real wood blinds be used in all rooms?',
          answer: 'Real wood blinds are ideal for most rooms including living rooms, bedrooms, dining rooms, and home offices. However, we don\'t recommend them for high-moisture areas like bathrooms or directly above kitchen sinks, as prolonged exposure to moisture can cause warping. For these areas, we suggest our moisture-resistant faux wood blinds instead.'
        },
        {
          question: 'How do I maintain real wood blinds?',
          answer: 'Real wood blinds are easy to maintain with regular dusting using a soft cloth or feather duster. For deeper cleaning, use a slightly damp cloth with a mild wood cleaner, being careful not to saturate the wood. Avoid harsh chemicals and excessive moisture. With proper care, real wood blinds will maintain their beauty for many years.'
        },
        {
          question: 'Are real wood blinds more expensive than faux wood?',
          answer: 'Yes, real wood blinds are a premium product and typically cost more than faux wood alternatives due to the natural materials and craftsmanship involved. However, they offer unmatched natural beauty, excellent insulation properties, and timeless appeal that many homeowners feel is worth the investment. We offer competitive pricing and whole house packages to provide the best value.'
        },
        {
          question: 'What finishes and stains are available?',
          answer: 'We offer a wide range of natural wood stains and finishes including light tones (natural pine, whitewash, light oak), medium tones (honey oak, natural wood), and dark tones (walnut, mahogany, espresso). We can also provide custom staining to match your existing woodwork or furniture.'
        },
        {
          question: 'Do real wood blinds help with energy efficiency?',
          answer: 'Yes! Real wood is a natural insulator and can help reduce heat loss in winter and keep rooms cooler in summer. This can contribute to lower energy bills and a more comfortable home environment throughout the year.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="relative rounded-2xl overflow-hidden shadow-xl order-2 md:order-1">
                <img
                  src="https://readdy.ai/api/search-image?query=real%20wood%20venetian%20blinds%20natural%20timber%20bedroom%20window%20warm%20oak%20finish%20natural%20grain%20texture%20elegant%20British%20home%20interior%20soft%20natural%20light%20sophisticated%20decor%20no%20people%20professional%20photography%20premium%20quality&width=800&height=600&seq=realwoodbedroom2025&orientation=landscape"
                  alt="Real Wood Blinds in Bedroom"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Natural Choice for Luxury
                </h3>
                <p className="text-gray-700 mb-6">
                  Real wood blinds bring unparalleled warmth and sophistication to your Northampton home. The natural beauty of genuine timber creates an inviting atmosphere that synthetic materials simply cannot match.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Unique Character</strong>
                      <p className="text-gray-600 text-sm">Each blind features natural wood grain patterns, making every installation truly one-of-a-kind</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Premium Craftsmanship</strong>
                      <p className="text-gray-600 text-sm">Expertly crafted from sustainably sourced timber with attention to every detail</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Long-Term Investment</strong>
                      <p className="text-gray-600 text-sm">Durable construction that maintains its beauty and functionality for decades</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Adds Property Value</strong>
                      <p className="text-gray-600 text-sm">Premium window treatments that enhance your home's appeal and market value</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
}